<script>
import DataTableStatusColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableStatusColumn.vue';

export default {
  name: 'HistoryStatusNotificationColumn',
  extends: DataTableStatusColumnVue,
  data: () => ({
    templateStatus: {
      1: {
        color: '#3FD65F',
        textColor: 'success',
        label: 'Configurado',
      },
      2: {
        color: '#F15F5F',
        textColor: 'error',
        label: 'Não configurado',
      },
    },
  }),
};
</script>
